import { Component, OnInit, SecurityContext } from '@angular/core';
import { OperationResult } from '../../../models/server-result/operation-result';
import { HttpErrorResponse } from '@angular/common/http';
import { ReportingApiService } from '../../../server-api/reporting-api.service';
import { ServerApiService } from '../../../server-api/server-api.service';
import { ToasterService } from '../../../shared-components/custom-toaster/toaster.service';
import { LogService } from '../../../services/log/log.service';
import { AppContextService } from '../../../services/app-context.service';
import { DateLocalePipe } from '../../../services/date-locale.pipe';
import { User } from '../../../models/User/user';
import { ConfirmingContract } from '../../../models/contracts/confirming/confirming-contract';
import { ConfirmingContractsSearchCriteria } from '../../../models/contracts/confirming/confirming-contracts-search-criteria';
import { ConfirmingConnectionsSearchCriteria } from '../../../models/contracts/confirming/confirming-connections-search-criteria';
import { ConfirmingConnection } from '../../../models/contracts/confirming/confirming-connection';
import { OperationError } from '../../../models/server-result/operation-error';
import { FactoringContractsSearchCriteria } from '../../../models/contracts/factoring/factoring-contracts-search-criteria';
import { FactoringConnectionsSearchCriteria } from '../../../models/contracts/factoring/factoring-connections-search-criteria';
import { FactoringConnection } from '../../../models/contracts/factoring/factoring-connection';
import { forkJoin, Observable } from 'rxjs';
import { FactoringContract } from '../../../models/contracts/factoring/factoring-contract';
import { UtilitiesService } from '../../../services/utils/utilities.service';
import { CommissionsSearchCriteria } from '../../../models/commissions/commissions-search-criteria';
import dayjs from '../../../services/dayjs-setup';
import { CommissionsSumValues } from '../../../models/commissions/commissions-sum-values';
import { CurrencyCode } from '../../../models/enums/currency-code';
import { DomSanitizer } from '@angular/platform-browser';
import { PendingApprovalDocumentsAmountDto } from '../../../models/dashboard/pending-approval-documents-amount-dto';
import { Router } from '@angular/router';
import { FileIntegrationStateService } from '../../../services/file-integration-state.service';
import { SearchFilesIntegrationComponent } from '../../files-integration/search-files-integration/search-files-integration.component';
import { FileStatus } from '../../../models/enums/FileIntegration/integration-file-status';
import { TranslateService } from '../../../services/translate/translate.service';

type CurrencyViewModel = {
	Currency: string;
	Selected: boolean;
};

@Component({
	selector: 'app-dashboard-administrator',
	templateUrl: './dashboard-administrator.component.html',
	styleUrls: ['../private-home.component.scss', './dashboard-administrator.component.scss'],
	standalone: false,
})
export class DashboardAdministratorComponent implements OnInit {
	public loggedUser: User | null = new User();
	public requestErrors: OperationError[] = [];

	public confirmingApprovedRequestFunds: number = 0;
	public confirmingNotPaidDocuments: number = 0;
	public confirmingBuyersWithActiveContractsCompaniesCount: number = 0;
	public confirmingSuppliersWithActiveConnectionsCompaniesCount: number = 0;
	public confirmingContractedAmount: number = 0;
	public confirmingContractsAvailableAmount: number = 0;

	public confirmingAverageMonthFundingRequestDays: number = 0;
	public confirmingCurrentFundingRequestsAmount: number = 0;
	public confirmingMonthlyAutomaticPayments: number = 0;
	public saphetyComission: number = 0;
	public confirmingSuppliersActiveConnections: number = 0;
	public confirmingContractsAvailableAmountRatio: number = 0;
	public confirmingPendingApprovalDocumentsAmount: number = 0;

	public CurrentMonth: Date;
	private month: number = new Date().getMonth() + 1;
	private year: number = new Date().getFullYear();

	public factoringApprovedCreditAssignments: number = 0;
	public factoringCurrentCreditAssignmentsAmount: number = 0;
	public factoringApprovedAdvances: number = 0;
	public factoringContractedAmount: number = 0;
	public factoringContractDocumentPortfolioAmount: number = 0;
	public factoringContractAdvanceableAmount: number = 0;
	public factoringSuppliersWithActiveContractsCompaniesCount: number = 0;
	public factoringBuyersWithActiveConnectionsCompaniesCount: number = 0;
	public factoringBuyersActiveConnections: number = 0;
	public factoringPendingApprovalDocumentsAmount: number = 0;

	public totalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections: number = 0;
	public totalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts: number = 0;
	public totalActiveConnections: number = 0;

	public selectedCurrency: string;
	public orderedCurrencies: CurrencyViewModel[] = [];

	public confirmingTabVisible: boolean = false;
	public factoringTabVisible: boolean = false;
	public confirmingTabSelected: boolean = false;
	public factoringTabSelected: boolean = false;

	protected CurrencyCode = CurrencyCode;
	protected FileStatus = FileStatus;

	public loadingConfirmingApprovedRequestFunds: boolean = false;
	public loadingConfirmingCurrentFundingRequestsAmount: boolean = false;
	public loadingConfirmingAverageMonthFundingRequestDays: boolean = false;
	public loadingConfirmingMonthlyAutomaticPayments: boolean = false;
	public loadingConfirmingNotPaidDocuments: boolean = false;
	public loadingConfirmingContractedAmount: boolean = false;
	public loadingConfirmingContractsAvailableAmount: boolean = false;
	public loadingConfirmingBuyersWithActiveContractsCompaniesCount: boolean = false;
	public loadingConfirmingSuppliersWithActiveConnectionsCompaniesCount: boolean = false;
	public loadingConfirmingSuppliersActiveConnections: boolean = false;
	public loadingConfirmingPendingApprovalDocumentsAmount: boolean = false;

	public loadingFactoringApprovedCreditAssignments: boolean = false;
	public loadingFactoringCurrentCreditAssignmentsAmount: boolean = false;
	public loadingFactoringApprovedAdvances: boolean = false;
	public loadingFactoringContractedAmount: boolean = false;
	public loadingFactoringContractDocumentPortfolioAmount: boolean = false;
	public loadingFactoringContractAdvanceableAmount: boolean = false;
	public loadingFactoringSuppliersWithActiveContractsCompaniesCount: boolean = false;
	public loadingFactoringBuyersWithActiveConnectionsCompaniesCount: boolean = false;
	public loadingFactoringBuyersActiveConnections: boolean = false;
	public loadingFactoringPendingApprovalDocumentsAmount: boolean = false;

	public loadingSaphetyComission: boolean = false;
	public loadingTotalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections: boolean = false;
	public loadingTotalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts: boolean = false;
	public loadingTotalActiveConnections: boolean = false;

	constructor(
		private reportingApiService: ReportingApiService,
		private serverApiService: ServerApiService,
		private toasterService: ToasterService,
		private logger: LogService,
		private utilitiesService: UtilitiesService,
		private appContext: AppContextService,
		private dateLocale: DateLocalePipe,
		private domSanitizer: DomSanitizer,
		private router: Router,
		private fileIntegrationStateService: FileIntegrationStateService,
		private translateService: TranslateService
	) {}

	ngOnInit() {
		this.appContext.getLoggedUserAsync().subscribe((userResult) => {
			this.loggedUser = userResult.Data;

			this.CurrentMonth = this.dateLocale.transform(new Date(), 'MM/yyyy');

			this.confirmingTabVisible = true;
			this.confirmingTabSelected = true;
			this.factoringTabVisible = true;
			this.factoringTabSelected = false;

			this.refreshAllData();
		});
	}

	public refreshAllData(): void {
		this.getSaphetyComission();
		this.getTotalCompaniesCount();
		this.loadConfirmingCards();
		this.loadFactoringCards();
	}

	private getConfirmingSuppliersActiveConnections(currency: string): void {
		this.loadingConfirmingSuppliersActiveConnections = true;
		this.reportingApiService.getConfirmingSuppliersActiveConnections(currency).subscribe({
			next: (opResult: OperationResult<number>) => {
				this.loadingConfirmingSuppliersActiveConnections = false;
				opResult.IsValid
					? (this.confirmingSuppliersActiveConnections = opResult.Data)
					: this.logger.error('[DashboardAdminitratorComponent] Invalid result from getConfirmingSuppliersActiveConnections()', opResult);
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.loadingConfirmingSuppliersActiveConnections = false;
				this.logger.error(
					'[DashboardAdminitratorComponent] Invalid result from getConfirmingSuppliersActiveConnections()',
					this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse)
				);
			},
		});
	}

	private getSaphetyComission(): void {
		this.loadingSaphetyComission = true;
		var date = new Date();
		var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

		const criteria = new CommissionsSearchCriteria();
		criteria.OrderBy = 'CreatedOn';
		criteria.PageNumber = 1;

		criteria.RowsPerPage = 2147483647;
		criteria.RestrictionCriteria = <CommissionsSearchCriteria>{
			CommissionDueDateEnd: dayjs.utc().year(lastDay.getFullYear()).month(lastDay.getMonth()).date(lastDay.getDate()).toDate(),
			CommissionDueDateStart: dayjs.utc().year(date.getFullYear()).month(date.getMonth()).date(1).toDate(),
		};

		this.serverApiService.getCommissionsSumValues(criteria.RestrictionCriteria).subscribe({
			next: (opResult: OperationResult<CommissionsSumValues[]>) => {
				this.loadingSaphetyComission = false;
				opResult.IsValid
					? this.processValidgetCommissionsSumValues(opResult)
					: this.logger.error('[DashboardAdminitratorComponent] Invalid result from getCommissionsSumValues()', opResult);
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.loadingSaphetyComission = false;
				this.logger.error(
					'[DashboardAdminitratorComponent] Invalid result from getCommissionsSumValues()',
					this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse)
				);
			},
		});
	}

	private getConfirmingMonthlyAutomaticPayments(currency: string): void {
		this.loadingConfirmingMonthlyAutomaticPayments = true;
		this.reportingApiService.getConfirmingMonthlyAutomaticPayments(this.month, this.year, currency).subscribe({
			next: (opResult: OperationResult<number>) => {
				this.loadingConfirmingMonthlyAutomaticPayments = false;
				opResult.IsValid
					? (this.confirmingMonthlyAutomaticPayments = opResult.Data)
					: this.logger.error('[DashboardAdminitratorComponent] Invalid result from getConfirmingMonthlyAutomaticPayments()', opResult);
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.loadingConfirmingMonthlyAutomaticPayments = false;
				this.logger.error(
					'[DashboardAdminitratorComponent] Invalid result from getConfirmingMonthlyAutomaticPayments()',
					this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse)
				);
			},
		});
	}

	private getConfirmingAverageMonthFundingRequestDays(currency: string): void {
		this.loadingConfirmingAverageMonthFundingRequestDays = true;
		this.reportingApiService.getConfirmingAverageMonthFundingRequestDays(this.month, this.year, currency).subscribe({
			next: (opResult: OperationResult<number>) => {
				this.loadingConfirmingAverageMonthFundingRequestDays = false;
				opResult.IsValid
					? (this.confirmingAverageMonthFundingRequestDays = opResult.Data)
					: this.logger.error(
							'[DashboardAdminitratorComponent] Invalid result from getConfirmingAverageMonthFundingRequestDays()',
							opResult
						);
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.loadingConfirmingAverageMonthFundingRequestDays = false;
				this.logger.error(
					'[DashboardAdminitratorComponent] Invalid result from getConfirmingAverageMonthFundingRequestDays()',
					this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse)
				);
			},
		});
	}

	private getConfirmingCurrentFundingRequestsAmount(currency: string): void {
		this.loadingConfirmingCurrentFundingRequestsAmount = true;
		this.reportingApiService.getConfirmingCurrentFundingRequestsAmount(currency).subscribe({
			next: (opResult: OperationResult<number>) => {
				this.loadingConfirmingCurrentFundingRequestsAmount = false;
				opResult.IsValid
					? (this.confirmingCurrentFundingRequestsAmount = opResult.Data)
					: this.logger.error('[DashboardAdminitratorComponent] Invalid result from getConfirmingCurrentFundingRequestsAmount()', opResult);
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.loadingConfirmingCurrentFundingRequestsAmount = false;
				this.logger.error(
					'[DashboardAdminitratorComponent] Invalid result from getConfirmingCurrentFundingRequestsAmount()',
					this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse)
				);
			},
		});
	}

	private getNotPaidDocumentsSum(currency: string): void {
		this.loadingConfirmingNotPaidDocuments = true;
		this.reportingApiService.getNotPaidDocumentsSum(currency).subscribe({
			next: (opResult: OperationResult<number>) => {
				this.loadingConfirmingNotPaidDocuments = false;
				opResult.IsValid
					? (this.confirmingNotPaidDocuments = opResult.Data)
					: this.logger.error('[DashboardAdminitratorComponent] Invalid result from getNotPaidDocumentsSum()', opResult);
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.loadingConfirmingNotPaidDocuments = false;
				this.logger.error(
					'[DashboardAdminitratorComponent] Invalid result from getNotPaidDocumentsSum()',
					this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse)
				);
			},
		});
	}

	private getConfirmingApprovedRequestFunds(currency: string) {
		this.loadingConfirmingApprovedRequestFunds = true;
		const fundingRequestDocumentStates = ['Approved'];

		this.reportingApiService.getConfirmingFundingRequestsTotalAdvancedAmount(fundingRequestDocumentStates, currency).subscribe({
			next: (opResult: OperationResult<number>) => {
				this.loadingConfirmingApprovedRequestFunds = false;
				opResult.IsValid
					? (this.confirmingApprovedRequestFunds = opResult.Data)
					: this.logger.error(
							'[DashboardAdminitratorComponent] Invalid result from getConfirmingFundingRequestsTotalAdvancedAmount',
							opResult
						);
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.loadingConfirmingApprovedRequestFunds = false;
				this.logger.error(
					'[DashboardAdminitratorComponent] HttpError result from getConfirmingFundingRequestsTotalAdvancedAmount',
					this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse)
				);
			},
		});
	}

	private getPendingApprovalDocumentsAmount(currency: string) {
		this.loadingConfirmingPendingApprovalDocumentsAmount = true;
		this.loadingFactoringPendingApprovalDocumentsAmount = true;
		this.reportingApiService.getPendingApprovalDocumentsAmount(currency).subscribe({
			next: (opResult: OperationResult<PendingApprovalDocumentsAmountDto>) => {
				this.loadingConfirmingPendingApprovalDocumentsAmount = false;
				this.loadingFactoringPendingApprovalDocumentsAmount = false;
				if (opResult.IsValid) {
					this.confirmingPendingApprovalDocumentsAmount = opResult.Data.Confirming;
					this.factoringPendingApprovalDocumentsAmount = opResult.Data.Factoring;
				} else {
					this.logger.error('[DashboardAdminitratorComponent] Invalid result from getPendingApprovalDocumentsAmount', opResult);
				}
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.loadingConfirmingPendingApprovalDocumentsAmount = false;
				this.loadingFactoringPendingApprovalDocumentsAmount = false;
				this.logger.error(
					'[DashboardAdminitratorComponent] HttpError result from getPendingApprovalDocumentsAmount',
					this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse)
				);
			},
		});
	}

	private refreshConfirmingContractDataForCurrency(currency: string) {
		this.loadingConfirmingContractedAmount = true;
		this.loadingConfirmingContractsAvailableAmount = true;
		this.loadingConfirmingBuyersWithActiveContractsCompaniesCount = true;

		this.confirmingContractedAmount = 0;
		this.confirmingContractsAvailableAmount = 0;
		this.confirmingContractsAvailableAmountRatio = 0;
		this.confirmingBuyersWithActiveContractsCompaniesCount = 0;

		const criteria: ConfirmingContractsSearchCriteria = new ConfirmingContractsSearchCriteria();
		criteria.OrderBy = 'EndDate';
		criteria.PageNumber = 1;
		criteria.OrderDescending = true;
		criteria.RowsPerPage = 2147483647;
		criteria.RestrictionCriteria = new ConfirmingContractsSearchCriteria();
		criteria.RestrictionCriteria.ContractStateList = ['Active'];
		criteria.RestrictionCriteria.Currency = currency;

		this.serverApiService.searchConfirmingContracts(criteria).subscribe((getConfirmingContracts) => {
			this.loadingConfirmingContractedAmount = false;
			this.loadingConfirmingContractsAvailableAmount = false;
			this.loadingConfirmingBuyersWithActiveContractsCompaniesCount = false;
			if (!getConfirmingContracts.IsValid) {
				let errors = getConfirmingContracts.Errors;
				if (errors && errors.length > 0) {
					this.toasterService.showError(this.translateService.translate('VALIDATION_FAILED', 'list-errorCodes'), {
						errors: errors,
						autoClose: false,
					});
				}
			} else {
				if (!!getConfirmingContracts.Data && getConfirmingContracts.Data.length > 0) {
					getConfirmingContracts.Data.forEach((contract) => {
						this.confirmingContractedAmount += contract.ContractedAmount;
						this.confirmingContractsAvailableAmount += contract.AvailableAmount;
						this.confirmingContractsAvailableAmountRatio =
							this.confirmingContractedAmount > 0 ? 100.0 * (this.confirmingContractsAvailableAmount / this.confirmingContractedAmount) : 0;
					});

					this.confirmingBuyersWithActiveContractsCompaniesCount = getConfirmingContracts.Data.map((c) => c.Buyer.Id).filter(
						(x, i, a) => a.indexOf(x) == i
					).length;
				}
			}
		});
	}

	private getConfirmingActiveContracts() {
		let currencies: CurrencyViewModel[] = [];
		let retrievedConfirmingContracts: ConfirmingContract[] = [];

		this.confirmingContractedAmount = 0;
		this.confirmingContractsAvailableAmount = 0;
		this.confirmingContractsAvailableAmountRatio = 0;
		this.confirmingBuyersWithActiveContractsCompaniesCount = 0;

		const criteria: ConfirmingContractsSearchCriteria = new ConfirmingContractsSearchCriteria();
		criteria.OrderBy = 'EndDate';
		criteria.PageNumber = 1;
		criteria.OrderDescending = true;
		criteria.RowsPerPage = 2147483647;
		criteria.RestrictionCriteria = new ConfirmingContractsSearchCriteria();
		criteria.RestrictionCriteria.ContractStateList = ['Active'];

		this.serverApiService.searchConfirmingContracts(criteria).subscribe({
			next: (getConfirmingContracts: OperationResult<ConfirmingContract[]>) => {
				if (getConfirmingContracts.IsValid) {
					if (!!getConfirmingContracts.Data && getConfirmingContracts.Data.length > 0) {
						getConfirmingContracts.Data.forEach((contract) => {
							retrievedConfirmingContracts.push(contract);

							if (currencies.findIndex((c) => c.Currency == contract.Currency) == -1)
								currencies.push(<CurrencyViewModel>{
									Currency: contract.Currency,
									Selected: false,
								});
						});

						this.orderedCurrencies = currencies.sort(function (c1: CurrencyViewModel, c2: CurrencyViewModel) {
							var currency1 = c1.Currency.toUpperCase();
							var currency2 = c2.Currency.toUpperCase();
							return currency1 < currency2 ? -1 : currency1 > currency2 ? 1 : 0;
						});

						if (!!this.orderedCurrencies && this.orderedCurrencies.length > 0) {
							let initialCurrencytoProcess = this.orderedCurrencies[0].Currency;
							this.orderedCurrencies[0].Selected = true;

							let contractsOfInitialCurrency: ConfirmingContract[] = retrievedConfirmingContracts.filter(
								(c) => c.Currency == initialCurrencytoProcess
							);

							contractsOfInitialCurrency.forEach((contract) => {
								this.confirmingContractedAmount += contract.ContractedAmount;
								this.confirmingContractsAvailableAmount += contract.AvailableAmount;
								this.confirmingContractsAvailableAmountRatio =
									this.confirmingContractedAmount > 0
										? 100.0 * (this.confirmingContractsAvailableAmount / this.confirmingContractedAmount)
										: 0;
							});

							this.confirmingBuyersWithActiveContractsCompaniesCount = contractsOfInitialCurrency
								.map((c) => c.Buyer.Id)
								.filter((x, i, a) => a.indexOf(x) == i).length;

							this.selectedCurrency = initialCurrencytoProcess;

							this.getConfirmingActiveConnections(this.selectedCurrency);
							this.getConfirmingSuppliersActiveConnections(this.selectedCurrency);
							this.getNotPaidDocumentsSum(this.selectedCurrency);
							this.getConfirmingApprovedRequestFunds(this.selectedCurrency);
							this.getConfirmingAverageMonthFundingRequestDays(this.selectedCurrency);
							this.getConfirmingCurrentFundingRequestsAmount(this.selectedCurrency);
							this.getConfirmingMonthlyAutomaticPayments(this.selectedCurrency);
							this.getPendingApprovalDocumentsAmount(this.selectedCurrency);
						}
					}
				} else {
					this.toasterService.showError(this.translateService.translate('ERROR_GET_COMPANY_CONTRACTS', 'list-errorCodes'));
				}
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				console.error('error: ' + httpErrorResponse.message);
				this.toasterService.showErrorFromHttpResponse(httpErrorResponse);
			},
		});
	}

	private getConfirmingActiveConnections(currency: string) {
		this.loadingConfirmingSuppliersWithActiveConnectionsCompaniesCount = true;
		const criteria: ConfirmingConnectionsSearchCriteria = new ConfirmingConnectionsSearchCriteria();
		criteria.PageNumber = 1;
		criteria.RowsPerPage = 2147483647;
		criteria.RestrictionCriteria = new ConfirmingConnectionsSearchCriteria();
		criteria.RestrictionCriteria.ConnectionStateList = ['Active'];
		criteria.RestrictionCriteria.ContractStateList = ['Active'];
		criteria.RestrictionCriteria.Currency = currency;

		this.serverApiService.searchConfirmingConnections(criteria).subscribe({
			next: (operationResult: OperationResult<ConfirmingConnection[]>) => {
				this.loadingConfirmingSuppliersWithActiveConnectionsCompaniesCount = false;
				if (operationResult.IsValid) {
					if (!!operationResult.Data) {
						if (operationResult.Data.length > 0)
							this.confirmingSuppliersWithActiveConnectionsCompaniesCount = operationResult.Data.map((c) => c.Supplier.Id).filter(
								(x, i, a) => a.indexOf(x) == i
							).length;
						else this.confirmingSuppliersWithActiveConnectionsCompaniesCount = 0;
					}
				} else {
					this.toasterService.showError(this.translateService.translate('ERROR_GET_COMPANY_CONTRACTS', 'list-errorCodes'));
				}
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.loadingConfirmingSuppliersWithActiveConnectionsCompaniesCount = false;
				console.error('error: ' + httpErrorResponse.message);
				this.toasterService.showErrorFromHttpResponse(httpErrorResponse);
			},
		});
	}

	public clickedCurrency(currency: string): void {
		this.selectedCurrency = currency;

		this.orderedCurrencies.forEach((orderedCurrency) => {
			orderedCurrency.Selected = orderedCurrency.Currency == currency;
		});

		this.refreshConfirmingContractDataForCurrency(this.selectedCurrency);
		this.getConfirmingActiveConnections(this.selectedCurrency);
		this.getConfirmingSuppliersActiveConnections(this.selectedCurrency);
		this.getNotPaidDocumentsSum(this.selectedCurrency);
		this.getConfirmingApprovedRequestFunds(this.selectedCurrency);
		this.getConfirmingAverageMonthFundingRequestDays(this.selectedCurrency);
		this.getConfirmingCurrentFundingRequestsAmount(this.selectedCurrency);
		this.getConfirmingMonthlyAutomaticPayments(this.selectedCurrency);
		this.getPendingApprovalDocumentsAmount(this.selectedCurrency);
	}

	public notMultipleCurrencies(currencies: CurrencyViewModel[]): boolean {
		return currencies?.length <= 1;
	}

	private getTotalCompaniesCount(): void {
		this.loadingTotalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections = true;
		this.loadingTotalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts = true;
		this.loadingTotalActiveConnections = true;
		const confirmingContractsSearchCriteria: ConfirmingContractsSearchCriteria = new ConfirmingContractsSearchCriteria();
		confirmingContractsSearchCriteria.PageNumber = 1;
		confirmingContractsSearchCriteria.OrderDescending = true;
		confirmingContractsSearchCriteria.RowsPerPage = 2147483647;
		confirmingContractsSearchCriteria.RestrictionCriteria = new ConfirmingContractsSearchCriteria();
		confirmingContractsSearchCriteria.RestrictionCriteria.ContractStateList = ['Active'];

		const confirmingConnectionsSearchCriteria: ConfirmingConnectionsSearchCriteria = new ConfirmingConnectionsSearchCriteria();
		confirmingConnectionsSearchCriteria.PageNumber = 1;
		confirmingConnectionsSearchCriteria.RowsPerPage = 2147483647;
		confirmingConnectionsSearchCriteria.RestrictionCriteria = new ConfirmingConnectionsSearchCriteria();
		confirmingConnectionsSearchCriteria.RestrictionCriteria.ConnectionStateList = ['Active'];
		confirmingConnectionsSearchCriteria.RestrictionCriteria.ContractStateList = ['Active'];

		const factoringContractsSearchCriteria: FactoringContractsSearchCriteria = new FactoringContractsSearchCriteria();
		factoringContractsSearchCriteria.PageNumber = 1;
		factoringContractsSearchCriteria.OrderDescending = true;
		factoringContractsSearchCriteria.RowsPerPage = 2147483647;
		factoringContractsSearchCriteria.RestrictionCriteria = new FactoringContractsSearchCriteria();
		factoringContractsSearchCriteria.RestrictionCriteria.ContractStateList = ['Active'];

		const factoringConnectionsSearchCriteria: FactoringConnectionsSearchCriteria = new FactoringConnectionsSearchCriteria();
		factoringConnectionsSearchCriteria.PageNumber = 1;
		factoringConnectionsSearchCriteria.RowsPerPage = 2147483647;
		factoringConnectionsSearchCriteria.RestrictionCriteria = new FactoringConnectionsSearchCriteria();
		factoringConnectionsSearchCriteria.RestrictionCriteria.ConnectionStateList = ['Active'];
		factoringConnectionsSearchCriteria.RestrictionCriteria.ContractStateList = ['Active'];

		let servicesCallsToMake: Array<
			Observable<OperationResult<ConfirmingConnection[] | ConfirmingContract[] | FactoringContract[] | FactoringConnection[]>>
		> = [];

		servicesCallsToMake.push(this.serverApiService.searchConfirmingContracts(confirmingContractsSearchCriteria));
		servicesCallsToMake.push(this.serverApiService.searchConfirmingConnections(confirmingConnectionsSearchCriteria));
		servicesCallsToMake.push(this.serverApiService.searchFactoringContracts(factoringContractsSearchCriteria));
		servicesCallsToMake.push(this.serverApiService.searchFactoringConnections(factoringConnectionsSearchCriteria));

		const getAllRequests = forkJoin(servicesCallsToMake);

		getAllRequests.subscribe((opResults) => {
			this.loadingTotalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections = false;
			this.loadingTotalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts = false;
			this.loadingTotalActiveConnections = false;
			let confirmingContractsSearchResult = opResults[0] as OperationResult<ConfirmingContract[]>;
			let confirmingConnectionsSearchResult = opResults[1] as OperationResult<ConfirmingConnection[]>;
			let factoringContractsSearchResult = opResults[2] as OperationResult<FactoringContract[]>;
			let factoringConnectionsSearchResult = opResults[3] as OperationResult<FactoringConnection[]>;

			if (
				confirmingContractsSearchResult.IsValid &&
				confirmingConnectionsSearchResult.IsValid &&
				factoringContractsSearchResult.IsValid &&
				factoringConnectionsSearchResult.IsValid
			) {
				let confirmingBuyersIds = confirmingContractsSearchResult.Data?.map((c) => c.Buyer.Id).filter(this.utilitiesService.notEmpty);

				let confirmingSuppliersIds = confirmingConnectionsSearchResult.Data?.map((c) => c.Supplier.Id).filter(
					this.utilitiesService.notEmpty
				);

				let factoringSuppliersIds = factoringContractsSearchResult.Data?.map((c) => c.Supplier.Id).filter(this.utilitiesService.notEmpty);

				let factoringBuyersIds = factoringConnectionsSearchResult.Data?.map((c) => c.Buyer.Id).filter(this.utilitiesService.notEmpty);

				this.totalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections =
					this.utilitiesService.getDistinctValues(confirmingBuyersIds.concat(factoringBuyersIds))?.length || 0;
				this.totalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts =
					this.utilitiesService.getDistinctValues(confirmingSuppliersIds.concat(factoringSuppliersIds))?.length || 0;

				this.totalActiveConnections = confirmingConnectionsSearchResult.Data.length + factoringConnectionsSearchResult.Data.length;
			}
		});
	}

	private loadConfirmingCards(): void {
		this.getConfirmingActiveContracts();
	}

	private getFactoringApprovedCreditAssignments(currency: string): void {
		this.loadingFactoringApprovedCreditAssignments = true;
		const creditAssignmentsDocumentStates = ['Approved'];

		this.reportingApiService.getFactoringApprovedCreditAssignments(creditAssignmentsDocumentStates, currency).subscribe({
			next: (opResult: OperationResult<number>) => {
				this.loadingFactoringApprovedCreditAssignments = false;
				opResult.IsValid
					? (this.factoringApprovedCreditAssignments = opResult.Data)
					: this.logger.error('[DashboardAdminitratorComponent] Invalid result from getFactoringApprovedCreditAssignments', opResult);
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.loadingFactoringApprovedCreditAssignments = false;
				this.logger.error(
					'[DashboardAdminitratorComponent] HttpError result from getFactoringApprovedCreditAssignments',
					this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse)
				);
			},
		});
	}

	private getFactoringCurrentCreditAssignmentsAmount(currency: string): void {
		this.loadingFactoringCurrentCreditAssignmentsAmount = true;
		this.reportingApiService.getFactoringCurrentCreditAssignmentsAmount(currency).subscribe({
			next: (opResult: OperationResult<number>) => {
				this.loadingFactoringCurrentCreditAssignmentsAmount = false;
				opResult.IsValid
					? (this.factoringCurrentCreditAssignmentsAmount = opResult.Data)
					: this.logger.error(
							'[DashboardAdminitratorComponent] Invalid result from getFactoringCurrentCreditAssignmentsAmount()',
							opResult
						);
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.loadingFactoringCurrentCreditAssignmentsAmount = false;
				this.logger.error(
					'[DashboardAdminitratorComponent] Invalid result from getFactoringCurrentCreditAssignmentsAmount()',
					this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse)
				);
			},
		});
	}

	private getFactoringApprovedAdvances(currency: string): void {
		this.loadingFactoringApprovedAdvances = true;
		const advancesStates = ['Approved'];

		this.reportingApiService.getFactoringApprovedAdvances(advancesStates, currency).subscribe({
			next: (opResult: OperationResult<number>) => {
				this.loadingFactoringApprovedAdvances = false;
				opResult.IsValid
					? (this.factoringApprovedAdvances = opResult.Data)
					: this.logger.error('[DashboardAdminitratorComponent] Invalid result from getFactoringApprovedAdvances', opResult);
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.loadingFactoringApprovedAdvances = false;
				this.logger.error(
					'[DashboardAdminitratorComponent] HttpError result from getFactoringApprovedAdvances',
					this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse)
				);
			},
		});
	}

	private getFactoringSuppliersWithActiveContractsCompaniesCount(): void {
		this.loadingFactoringContractedAmount = true;
		this.loadingFactoringContractAdvanceableAmount = true;
		this.loadingFactoringContractDocumentPortfolioAmount = true;
		this.loadingFactoringSuppliersWithActiveContractsCompaniesCount = true;

		this.factoringContractedAmount = 0;
		this.factoringContractAdvanceableAmount = 0;
		this.factoringContractDocumentPortfolioAmount = 0;
		this.factoringSuppliersWithActiveContractsCompaniesCount = 0;

		const criteria: FactoringContractsSearchCriteria = new FactoringContractsSearchCriteria();
		criteria.PageNumber = 1;
		criteria.OrderDescending = true;
		criteria.RowsPerPage = 2147483647;
		criteria.RestrictionCriteria = new FactoringContractsSearchCriteria();
		criteria.RestrictionCriteria.ContractStateList = ['Active'];

		this.serverApiService.searchFactoringContracts(criteria).subscribe((getFactoringContracts) => {
			this.loadingFactoringContractedAmount = false;
			this.loadingFactoringContractAdvanceableAmount = false;
			this.loadingFactoringContractDocumentPortfolioAmount = false;
			this.loadingFactoringSuppliersWithActiveContractsCompaniesCount = false;
			if (!getFactoringContracts.IsValid) {
				let errors = getFactoringContracts.Errors;
				if (errors && errors.length > 0) {
					this.toasterService.showError(this.translateService.translate('VALIDATION_FAILED', 'list-errorCodes'), {
						errors: errors,
						autoClose: false,
					});
				}
			} else {
				if (!!getFactoringContracts.Data && getFactoringContracts.Data.length > 0) {
					getFactoringContracts.Data.forEach((contract) => {
						this.factoringContractedAmount += contract.ContractAmount;
						this.factoringContractAdvanceableAmount += contract.AdvanceableAmount;
						this.factoringContractDocumentPortfolioAmount += contract.DocumentPortfolioAmount;
					});

					this.factoringSuppliersWithActiveContractsCompaniesCount = getFactoringContracts.Data.map((c) => c.Supplier.Id).filter(
						(x, i, a) => a.indexOf(x) == i
					).length;
				}
			}
		});
	}

	private getFactoringBuyersWithActiveConnectionsCompaniesCount() {
		this.loadingFactoringBuyersWithActiveConnectionsCompaniesCount = true;
		const criteria: FactoringConnectionsSearchCriteria = new FactoringConnectionsSearchCriteria();
		criteria.PageNumber = 1;
		criteria.RowsPerPage = 2147483647;
		criteria.RestrictionCriteria = new FactoringConnectionsSearchCriteria();
		criteria.RestrictionCriteria.ConnectionStateList = ['Active'];
		criteria.RestrictionCriteria.ContractStateList = ['Active'];

		this.serverApiService.searchFactoringConnections(criteria).subscribe({
			next: (operationResult: OperationResult<FactoringConnection[]>) => {
				this.loadingFactoringBuyersWithActiveConnectionsCompaniesCount = false;
				if (operationResult.IsValid) {
					if (!!operationResult.Data && operationResult.Data.length > 0) {
						this.factoringBuyersWithActiveConnectionsCompaniesCount = operationResult.Data.map((c) => c.Buyer.Id).filter(
							(x, i, a) => a.indexOf(x) == i
						).length;
					}
				} else {
					this.toasterService.showError(this.translateService.translate('ERROR_GET_COMPANY_CONTRACTS', 'list-errorCodes'));
				}
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.loadingFactoringBuyersWithActiveConnectionsCompaniesCount = false;
				console.error('error: ' + httpErrorResponse.message);
				this.toasterService.showErrorFromHttpResponse(httpErrorResponse);
			},
		});
	}

	private getFactoringBuyersActiveConnections() {
		this.loadingFactoringBuyersActiveConnections = true;
		this.reportingApiService.getFactoringBuyersActiveConnections().subscribe({
			next: (opResult: OperationResult<number>) => {
				this.loadingFactoringBuyersActiveConnections = false;
				opResult.IsValid
					? (this.factoringBuyersActiveConnections = opResult.Data)
					: this.logger.error('[DashboardAdminitratorComponent] Invalid result from getFactoringBuyersActiveConnections()', opResult);
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.loadingFactoringBuyersActiveConnections = false;
				this.logger.error(
					'[DashboardAdminitratorComponent] Invalid result from getFactoringBuyersActiveConnections()',
					this.domSanitizer.sanitize(SecurityContext.HTML, httpErrorResponse)
				);
			},
		});
	}

	private loadFactoringCards(): void {
		this.getFactoringApprovedCreditAssignments(CurrencyCode.Euro);
		this.getFactoringCurrentCreditAssignmentsAmount(CurrencyCode.Euro);
		this.getFactoringApprovedAdvances(CurrencyCode.Euro);
		this.getFactoringSuppliersWithActiveContractsCompaniesCount();
		this.getFactoringBuyersWithActiveConnectionsCompaniesCount();
		this.getFactoringBuyersActiveConnections();
	}

	public clickedConfirmingTab(): void {
		this.confirmingTabSelected = true;
		this.factoringTabSelected = false;
	}

	public clickedFactoringTab(): void {
		this.confirmingTabSelected = false;
		this.factoringTabSelected = true;
		this.selectedCurrency = CurrencyCode.Euro;
	}

	private processValidgetCommissionsSumValues(operationResult: OperationResult<any[]>): void {
		let commissionsSumValues = operationResult.Data.filter((c) => c.ConversionCurrency == CurrencyCode.Euro);

		const reducer = (accumulator, currentValue) => accumulator + currentValue;
		this.saphetyComission = commissionsSumValues?.map((v) => v.Sum)?.reduce(reducer, 0) ?? 0;
	}

	public navigateToSovosCommissions(): void {
		this.router.navigateByUrl('/private/administration/commissions');
	}

	public navigateToFilesIntegration(key: string): void {
		SearchFilesIntegrationComponent.navigateWithFileStatus(this.router, this.fileIntegrationStateService, key);
	}
}
